/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * Recipe Binder Digitizer API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddFavorite200,
  AddRecipeToFavoriteCollection200,
  BatchExtract200,
  BulkDeleteRecipes200,
  BulkDeleteRequest,
  BulkStatusRequest,
  BulkUpdateStatus200,
  CreateFavoriteCollectionBody,
  DeleteFavoriteCollection200,
  DeleteRecipe200,
  ExtractImage200,
  ExtractImageBody,
  ExtractionJobStatus,
  ExtractionStatus,
  FavoriteCollectionRecord,
  GetFavoriteCollection200,
  GroupImages200,
  GroupImagesRequest,
  HealthStatus,
  ListCollectionsForRecipe200,
  ListFavoriteCollections200,
  ListFavorites200,
  ListImages200,
  ListImagesParams,
  ListRecipeCategories200,
  ListRecipes200,
  ListRecipesParams,
  ListTags200,
  MergeRecipes200,
  RecipeDetail,
  RemoveFavorite200,
  RemoveRecipeFromFavoriteCollection200,
  RetryAllErrors200,
  RetryExtraction200,
  SplitRecipe200,
  SplitRecipeRequest,
  UngroupImages200,
  UpdateFavoriteCollectionBody,
  UpdateRecipeRequest,
  UploadHeroImageBody,
  UploadImages200,
  UploadImagesBody
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListImagesUrl = (params?: ListImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/images?${stringifiedParams}` : `/api/images`
}

/**
 * @summary List all images
 */
export const listImages = async (params?: ListImagesParams, options?: Parameters<typeof customFetch>[1]): Promise<ListImages200> => {

  return customFetch<ListImages200>(getListImagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImagesQueryKey = (params?: ListImagesParams,) => {
    return [
    `/api/images`, ...(params ? [params] : [])
    ] as const;
    }


export const getListImagesQueryOptions = <TData = Awaited<ReturnType<typeof listImages>>, TError = ErrorType<unknown>>(params?: ListImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImages>>> = ({ signal }) => listImages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listImages>>>
export type ListImagesQueryError = ErrorType<unknown>


export function useListImages<TData = Awaited<ReturnType<typeof listImages>>, TError = ErrorType<unknown>>(
 params: undefined |  ListImagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImages>>,
          TError,
          Awaited<ReturnType<typeof listImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImages<TData = Awaited<ReturnType<typeof listImages>>, TError = ErrorType<unknown>>(
 params?: ListImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImages>>,
          TError,
          Awaited<ReturnType<typeof listImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImages<TData = Awaited<ReturnType<typeof listImages>>, TError = ErrorType<unknown>>(
 params?: ListImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all images
 */

export function useListImages<TData = Awaited<ReturnType<typeof listImages>>, TError = ErrorType<unknown>>(
 params?: ListImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadImagesUrl = () => {




  return `/api/images/upload`
}

/**
 * @summary Upload images
 */
export const uploadImages = async (uploadImagesBody: UploadImagesBody, options?: Parameters<typeof customFetch>[1]): Promise<UploadImages200> => {
    const formData = new FormData();
uploadImagesBody.images.forEach(value => formData.append(`images`, value));
if(uploadImagesBody.batchId !== undefined) {
 formData.append(`batchId`, uploadImagesBody.batchId);
 }

  return customFetch<UploadImages200>(getUploadImagesUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadImagesMutationKey = () => ['uploadImages'] as const;

export const getUploadImagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImages>>, TError,UploadImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImages>>, TError,UploadImagesMutationVariables, TContext> => {

const mutationKey = getUploadImagesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImages>>, UploadImagesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadImages(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImagesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImages>>>
    export type UploadImagesMutationBody = BodyType<UploadImagesBody>
    export type UploadImagesMutationError = ErrorType<unknown>
    export type UploadImagesMutationVariables = {data: BodyType<UploadImagesBody>}

    /**
 * @summary Upload images
 */
export const useUploadImages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImages>>, TError,UploadImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadImages>>,
        TError,
        UploadImagesMutationVariables,
        TContext
      > => {
      return useMutation(getUploadImagesMutationOptions(options), queryClient);
    }

export const getGroupImagesUrl = () => {




  return `/api/images/group`
}

/**
 * @summary Group images as multi-page recipe
 */
export const groupImages = async (groupImagesRequest: GroupImagesRequest, options?: Parameters<typeof customFetch>[1]): Promise<GroupImages200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GroupImages200>(getGroupImagesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(groupImagesRequest)
  }
);}





export const getGroupImagesMutationKey = () => ['groupImages'] as const;

export const getGroupImagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupImages>>, TError,GroupImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof groupImages>>, TError,GroupImagesMutationVariables, TContext> => {

const mutationKey = getGroupImagesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupImages>>, GroupImagesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  groupImages(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GroupImagesMutationResult = NonNullable<Awaited<ReturnType<typeof groupImages>>>
    export type GroupImagesMutationBody = BodyType<GroupImagesRequest>
    export type GroupImagesMutationError = ErrorType<unknown>
    export type GroupImagesMutationVariables = {data: BodyType<GroupImagesRequest>}

    /**
 * @summary Group images as multi-page recipe
 */
export const useGroupImages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupImages>>, TError,GroupImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupImages>>,
        TError,
        GroupImagesMutationVariables,
        TContext
      > => {
      return useMutation(getGroupImagesMutationOptions(options), queryClient);
    }

export const getUngroupImagesUrl = (groupId: number,) => {




  return `/api/images/group/${groupId}`
}

/**
 * @summary Ungroup images by group ID
 */
export const ungroupImages = async (groupId: number, options?: Parameters<typeof customFetch>[1]): Promise<UngroupImages200> => {

  return customFetch<UngroupImages200>(getUngroupImagesUrl(groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUngroupImagesMutationKey = () => ['ungroupImages'] as const;

export const getUngroupImagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ungroupImages>>, TError,UngroupImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ungroupImages>>, TError,UngroupImagesMutationVariables, TContext> => {

const mutationKey = getUngroupImagesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ungroupImages>>, UngroupImagesMutationVariables> = (props) => {
          const {groupId} = props ?? {};

          return  ungroupImages(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UngroupImagesMutationResult = NonNullable<Awaited<ReturnType<typeof ungroupImages>>>

    export type UngroupImagesMutationError = ErrorType<unknown>
    export type UngroupImagesMutationVariables = {groupId: number}

    /**
 * @summary Ungroup images by group ID
 */
export const useUngroupImages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ungroupImages>>, TError,UngroupImagesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ungroupImages>>,
        TError,
        UngroupImagesMutationVariables,
        TContext
      > => {
      return useMutation(getUngroupImagesMutationOptions(options), queryClient);
    }

export const getGetExtractionStatusUrl = () => {




  return `/api/extraction-status`
}

/**
 * @summary Get extraction status counts
 */
export const getExtractionStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<ExtractionStatus> => {

  return customFetch<ExtractionStatus>(getGetExtractionStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExtractionStatusQueryKey = () => {
    return [
    `/api/extraction-status`
    ] as const;
    }


export const getGetExtractionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getExtractionStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExtractionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtractionStatus>>> = ({ signal }) => getExtractionStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExtractionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getExtractionStatus>>>
export type GetExtractionStatusQueryError = ErrorType<unknown>


export function useGetExtractionStatus<TData = Awaited<ReturnType<typeof getExtractionStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtractionStatus>>,
          TError,
          Awaited<ReturnType<typeof getExtractionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtractionStatus<TData = Awaited<ReturnType<typeof getExtractionStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtractionStatus>>,
          TError,
          Awaited<ReturnType<typeof getExtractionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtractionStatus<TData = Awaited<ReturnType<typeof getExtractionStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get extraction status counts
 */

export function useGetExtractionStatus<TData = Awaited<ReturnType<typeof getExtractionStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExtractionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExtractImageUrl = () => {




  return `/api/extract`
}

/**
 * Returns immediately with a job id; clients should poll
 * `/extract/job/{jobId}` for completion and the resulting recipe ids.
 * @summary Enqueue extraction of a single image or group
 */
export const extractImage = async (extractImageBody: ExtractImageBody, options?: Parameters<typeof customFetch>[1]): Promise<ExtractImage200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtractImage200>(getExtractImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(extractImageBody)
  }
);}





export const getExtractImageMutationKey = () => ['extractImage'] as const;

export const getExtractImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractImage>>, TError,ExtractImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof extractImage>>, TError,ExtractImageMutationVariables, TContext> => {

const mutationKey = getExtractImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractImage>>, ExtractImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  extractImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractImageMutationResult = NonNullable<Awaited<ReturnType<typeof extractImage>>>
    export type ExtractImageMutationBody = BodyType<ExtractImageBody>
    export type ExtractImageMutationError = ErrorType<unknown>
    export type ExtractImageMutationVariables = {data: BodyType<ExtractImageBody>}

    /**
 * @summary Enqueue extraction of a single image or group
 */
export const useExtractImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractImage>>, TError,ExtractImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extractImage>>,
        TError,
        ExtractImageMutationVariables,
        TContext
      > => {
      return useMutation(getExtractImageMutationOptions(options), queryClient);
    }

export const getGetExtractionJobUrl = (jobId: string,) => {




  return `/api/extract/job/${jobId}`
}

/**
 * @summary Poll the status of an enqueued extraction job
 */
export const getExtractionJob = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtractionJobStatus> => {

  return customFetch<ExtractionJobStatus>(getGetExtractionJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExtractionJobQueryKey = (jobId: string,) => {
    return [
    `/api/extract/job/${jobId}`
    ] as const;
    }


export const getGetExtractionJobQueryOptions = <TData = Awaited<ReturnType<typeof getExtractionJob>>, TError = ErrorType<void>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExtractionJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtractionJob>>> = ({ signal }) => getExtractionJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExtractionJobQueryResult = NonNullable<Awaited<ReturnType<typeof getExtractionJob>>>
export type GetExtractionJobQueryError = ErrorType<void>


export function useGetExtractionJob<TData = Awaited<ReturnType<typeof getExtractionJob>>, TError = ErrorType<void>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtractionJob>>,
          TError,
          Awaited<ReturnType<typeof getExtractionJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtractionJob<TData = Awaited<ReturnType<typeof getExtractionJob>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtractionJob>>,
          TError,
          Awaited<ReturnType<typeof getExtractionJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtractionJob<TData = Awaited<ReturnType<typeof getExtractionJob>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Poll the status of an enqueued extraction job
 */

export function useGetExtractionJob<TData = Awaited<ReturnType<typeof getExtractionJob>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtractionJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExtractionJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBatchExtractUrl = () => {




  return `/api/extract/batch`
}

/**
 * @summary Start batch extraction of all pending images
 */
export const batchExtract = async ( options?: Parameters<typeof customFetch>[1]): Promise<BatchExtract200> => {

  return customFetch<BatchExtract200>(getBatchExtractUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBatchExtractMutationKey = () => ['batchExtract'] as const;

export const getBatchExtractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchExtract>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof batchExtract>>, TError,void, TContext> => {

const mutationKey = getBatchExtractMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchExtract>>, void> = () => {


          return  batchExtract(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchExtractMutationResult = NonNullable<Awaited<ReturnType<typeof batchExtract>>>

    export type BatchExtractMutationError = ErrorType<unknown>


    /**
 * @summary Start batch extraction of all pending images
 */
export const useBatchExtract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchExtract>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchExtract>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBatchExtractMutationOptions(options), queryClient);
    }

export const getRetryAllErrorsUrl = () => {




  return `/api/extract/retry-errors`
}

/**
 * @summary Reset all error images to pending and start batch extraction
 */
export const retryAllErrors = async ( options?: Parameters<typeof customFetch>[1]): Promise<RetryAllErrors200> => {

  return customFetch<RetryAllErrors200>(getRetryAllErrorsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryAllErrorsMutationKey = () => ['retryAllErrors'] as const;

export const getRetryAllErrorsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAllErrors>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryAllErrors>>, TError,void, TContext> => {

const mutationKey = getRetryAllErrorsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAllErrors>>, void> = () => {


          return  retryAllErrors(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAllErrorsMutationResult = NonNullable<Awaited<ReturnType<typeof retryAllErrors>>>

    export type RetryAllErrorsMutationError = ErrorType<unknown>


    /**
 * @summary Reset all error images to pending and start batch extraction
 */
export const useRetryAllErrors = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAllErrors>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryAllErrors>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRetryAllErrorsMutationOptions(options), queryClient);
    }

export const getRetryExtractionUrl = (imageId: number,) => {




  return `/api/extract/retry/${imageId}`
}

/**
 * @summary Re-enqueue extraction for a failed image
 */
export const retryExtraction = async (imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<RetryExtraction200> => {

  return customFetch<RetryExtraction200>(getRetryExtractionUrl(imageId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryExtractionMutationKey = () => ['retryExtraction'] as const;

export const getRetryExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryExtraction>>, TError,RetryExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryExtraction>>, TError,RetryExtractionMutationVariables, TContext> => {

const mutationKey = getRetryExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryExtraction>>, RetryExtractionMutationVariables> = (props) => {
          const {imageId} = props ?? {};

          return  retryExtraction(imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof retryExtraction>>>

    export type RetryExtractionMutationError = ErrorType<unknown>
    export type RetryExtractionMutationVariables = {imageId: number}

    /**
 * @summary Re-enqueue extraction for a failed image
 */
export const useRetryExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryExtraction>>, TError,RetryExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryExtraction>>,
        TError,
        RetryExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getRetryExtractionMutationOptions(options), queryClient);
    }

export const getBulkUpdateStatusUrl = () => {




  return `/api/recipes/bulk-status`
}

/**
 * @summary Bulk update validation status for multiple recipes
 */
export const bulkUpdateStatus = async (bulkStatusRequest: BulkStatusRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkUpdateStatus200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkUpdateStatus200>(getBulkUpdateStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkStatusRequest)
  }
);}





export const getBulkUpdateStatusMutationKey = () => ['bulkUpdateStatus'] as const;

export const getBulkUpdateStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateStatus>>, TError,BulkUpdateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateStatus>>, TError,BulkUpdateStatusMutationVariables, TContext> => {

const mutationKey = getBulkUpdateStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateStatus>>, BulkUpdateStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkUpdateStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateStatus>>>
    export type BulkUpdateStatusMutationBody = BodyType<BulkStatusRequest>
    export type BulkUpdateStatusMutationError = ErrorType<unknown>
    export type BulkUpdateStatusMutationVariables = {data: BodyType<BulkStatusRequest>}

    /**
 * @summary Bulk update validation status for multiple recipes
 */
export const useBulkUpdateStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateStatus>>, TError,BulkUpdateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateStatus>>,
        TError,
        BulkUpdateStatusMutationVariables,
        TContext
      > => {
      return useMutation(getBulkUpdateStatusMutationOptions(options), queryClient);
    }

export const getBulkDeleteRecipesUrl = () => {




  return `/api/recipes/bulk-delete`
}

/**
 * @summary Bulk delete multiple recipes
 */
export const bulkDeleteRecipes = async (bulkDeleteRequest: BulkDeleteRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkDeleteRecipes200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkDeleteRecipes200>(getBulkDeleteRecipesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkDeleteRequest)
  }
);}





export const getBulkDeleteRecipesMutationKey = () => ['bulkDeleteRecipes'] as const;

export const getBulkDeleteRecipesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteRecipes>>, TError,BulkDeleteRecipesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteRecipes>>, TError,BulkDeleteRecipesMutationVariables, TContext> => {

const mutationKey = getBulkDeleteRecipesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteRecipes>>, BulkDeleteRecipesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteRecipes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteRecipesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteRecipes>>>
    export type BulkDeleteRecipesMutationBody = BodyType<BulkDeleteRequest>
    export type BulkDeleteRecipesMutationError = ErrorType<unknown>
    export type BulkDeleteRecipesMutationVariables = {data: BodyType<BulkDeleteRequest>}

    /**
 * @summary Bulk delete multiple recipes
 */
export const useBulkDeleteRecipes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteRecipes>>, TError,BulkDeleteRecipesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteRecipes>>,
        TError,
        BulkDeleteRecipesMutationVariables,
        TContext
      > => {
      return useMutation(getBulkDeleteRecipesMutationOptions(options), queryClient);
    }

export const getListRecipeCategoriesUrl = () => {




  return `/api/recipes/categories`
}

/**
 * @summary List all recipe categories with counts
 */
export const listRecipeCategories = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListRecipeCategories200> => {

  return customFetch<ListRecipeCategories200>(getListRecipeCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecipeCategoriesQueryKey = () => {
    return [
    `/api/recipes/categories`
    ] as const;
    }


export const getListRecipeCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listRecipeCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecipeCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecipeCategories>>> = ({ signal }) => listRecipeCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecipeCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listRecipeCategories>>>
export type ListRecipeCategoriesQueryError = ErrorType<unknown>


export function useListRecipeCategories<TData = Awaited<ReturnType<typeof listRecipeCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecipeCategories>>,
          TError,
          Awaited<ReturnType<typeof listRecipeCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecipeCategories<TData = Awaited<ReturnType<typeof listRecipeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecipeCategories>>,
          TError,
          Awaited<ReturnType<typeof listRecipeCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecipeCategories<TData = Awaited<ReturnType<typeof listRecipeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all recipe categories with counts
 */

export function useListRecipeCategories<TData = Awaited<ReturnType<typeof listRecipeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipeCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecipeCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRecipesUrl = (params?: ListRecipesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/recipes?${stringifiedParams}` : `/api/recipes`
}

/**
 * @summary List all extracted recipes
 */
export const listRecipes = async (params?: ListRecipesParams, options?: Parameters<typeof customFetch>[1]): Promise<ListRecipes200> => {

  return customFetch<ListRecipes200>(getListRecipesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecipesQueryKey = (params?: ListRecipesParams,) => {
    return [
    `/api/recipes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRecipesQueryOptions = <TData = Awaited<ReturnType<typeof listRecipes>>, TError = ErrorType<unknown>>(params?: ListRecipesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecipesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecipes>>> = ({ signal }) => listRecipes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecipesQueryResult = NonNullable<Awaited<ReturnType<typeof listRecipes>>>
export type ListRecipesQueryError = ErrorType<unknown>


export function useListRecipes<TData = Awaited<ReturnType<typeof listRecipes>>, TError = ErrorType<unknown>>(
 params: undefined |  ListRecipesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecipes>>,
          TError,
          Awaited<ReturnType<typeof listRecipes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecipes<TData = Awaited<ReturnType<typeof listRecipes>>, TError = ErrorType<unknown>>(
 params?: ListRecipesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecipes>>,
          TError,
          Awaited<ReturnType<typeof listRecipes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecipes<TData = Awaited<ReturnType<typeof listRecipes>>, TError = ErrorType<unknown>>(
 params?: ListRecipesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all extracted recipes
 */

export function useListRecipes<TData = Awaited<ReturnType<typeof listRecipes>>, TError = ErrorType<unknown>>(
 params?: ListRecipesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecipes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecipesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTagsUrl = () => {




  return `/api/tags`
}

/**
 * @summary List all known tags (starter + user-created) with usage counts
 */
export const listTags = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListTags200> => {

  return customFetch<ListTags200>(getListTagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTagsQueryKey = () => {
    return [
    `/api/tags`
    ] as const;
    }


export const getListTagsQueryOptions = <TData = Awaited<ReturnType<typeof listTags>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTags>>> = ({ signal }) => listTags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listTags>>>
export type ListTagsQueryError = ErrorType<unknown>


export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all known tags (starter + user-created) with usage counts
 */

export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMergeRecipesUrl = (id: number,
    otherId: number,) => {




  return `/api/recipes/${id}/merge/${otherId}`
}

/**
 * @summary Merge otherId recipe into id recipe (otherId is deleted, id survives)
 */
export const mergeRecipes = async (id: number,
    otherId: number, options?: Parameters<typeof customFetch>[1]): Promise<MergeRecipes200> => {

  return customFetch<MergeRecipes200>(getMergeRecipesUrl(id,otherId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMergeRecipesMutationKey = () => ['mergeRecipes'] as const;

export const getMergeRecipesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeRecipes>>, TError,MergeRecipesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeRecipes>>, TError,MergeRecipesMutationVariables, TContext> => {

const mutationKey = getMergeRecipesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeRecipes>>, MergeRecipesMutationVariables> = (props) => {
          const {id,otherId} = props ?? {};

          return  mergeRecipes(id,otherId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeRecipesMutationResult = NonNullable<Awaited<ReturnType<typeof mergeRecipes>>>

    export type MergeRecipesMutationError = ErrorType<unknown>
    export type MergeRecipesMutationVariables = {id: number;otherId: number}

    /**
 * @summary Merge otherId recipe into id recipe (otherId is deleted, id survives)
 */
export const useMergeRecipes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeRecipes>>, TError,MergeRecipesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mergeRecipes>>,
        TError,
        MergeRecipesMutationVariables,
        TContext
      > => {
      return useMutation(getMergeRecipesMutationOptions(options), queryClient);
    }

export const getSplitRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}/split`
}

/**
 * @summary Split selected ingredients off into a new recipe
 */
export const splitRecipe = async (id: number,
    splitRecipeRequest: SplitRecipeRequest, options?: Parameters<typeof customFetch>[1]): Promise<SplitRecipe200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SplitRecipe200>(getSplitRecipeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(splitRecipeRequest)
  }
);}





export const getSplitRecipeMutationKey = () => ['splitRecipe'] as const;

export const getSplitRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitRecipe>>, TError,SplitRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof splitRecipe>>, TError,SplitRecipeMutationVariables, TContext> => {

const mutationKey = getSplitRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof splitRecipe>>, SplitRecipeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  splitRecipe(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SplitRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof splitRecipe>>>
    export type SplitRecipeMutationBody = BodyType<SplitRecipeRequest>
    export type SplitRecipeMutationError = ErrorType<unknown>
    export type SplitRecipeMutationVariables = {id: number;data: BodyType<SplitRecipeRequest>}

    /**
 * @summary Split selected ingredients off into a new recipe
 */
export const useSplitRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitRecipe>>, TError,SplitRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof splitRecipe>>,
        TError,
        SplitRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getSplitRecipeMutationOptions(options), queryClient);
    }

export const getGetRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}`
}

/**
 * @summary Get a single recipe with full detail
 */
export const getRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

  return customFetch<RecipeDetail>(getGetRecipeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecipeQueryKey = (id: number,) => {
    return [
    `/api/recipes/${id}`
    ] as const;
    }


export const getGetRecipeQueryOptions = <TData = Awaited<ReturnType<typeof getRecipe>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecipeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipe>>> = ({ signal }) => getRecipe(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecipeQueryResult = NonNullable<Awaited<ReturnType<typeof getRecipe>>>
export type GetRecipeQueryError = ErrorType<unknown>


export function useGetRecipe<TData = Awaited<ReturnType<typeof getRecipe>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipe>>,
          TError,
          Awaited<ReturnType<typeof getRecipe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipe<TData = Awaited<ReturnType<typeof getRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipe>>,
          TError,
          Awaited<ReturnType<typeof getRecipe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipe<TData = Awaited<ReturnType<typeof getRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single recipe with full detail
 */

export function useGetRecipe<TData = Awaited<ReturnType<typeof getRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecipeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}`
}

/**
 * @summary Update recipe fields and/or ingredients
 */
export const updateRecipe = async (id: number,
    updateRecipeRequest: UpdateRecipeRequest, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RecipeDetail>(getUpdateRecipeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRecipeRequest)
  }
);}





export const getUpdateRecipeMutationKey = () => ['updateRecipe'] as const;

export const getUpdateRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecipe>>, TError,UpdateRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecipe>>, TError,UpdateRecipeMutationVariables, TContext> => {

const mutationKey = getUpdateRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecipe>>, UpdateRecipeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateRecipe(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecipe>>>
    export type UpdateRecipeMutationBody = BodyType<UpdateRecipeRequest>
    export type UpdateRecipeMutationError = ErrorType<unknown>
    export type UpdateRecipeMutationVariables = {id: number;data: BodyType<UpdateRecipeRequest>}

    /**
 * @summary Update recipe fields and/or ingredients
 */
export const useUpdateRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecipe>>, TError,UpdateRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRecipe>>,
        TError,
        UpdateRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRecipeMutationOptions(options), queryClient);
    }

export const getDeleteRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}`
}

/**
 * @summary Delete a recipe
 */
export const deleteRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<DeleteRecipe200> => {

  return customFetch<DeleteRecipe200>(getDeleteRecipeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRecipeMutationKey = () => ['deleteRecipe'] as const;

export const getDeleteRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecipe>>, TError,DeleteRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRecipe>>, TError,DeleteRecipeMutationVariables, TContext> => {

const mutationKey = getDeleteRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRecipe>>, DeleteRecipeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteRecipe(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRecipe>>>

    export type DeleteRecipeMutationError = ErrorType<unknown>
    export type DeleteRecipeMutationVariables = {id: number}

    /**
 * @summary Delete a recipe
 */
export const useDeleteRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecipe>>, TError,DeleteRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRecipe>>,
        TError,
        DeleteRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteRecipeMutationOptions(options), queryClient);
    }

export const getValidateRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}/validate`
}

/**
 * @summary Mark recipe as validated
 */
export const validateRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

  return customFetch<RecipeDetail>(getValidateRecipeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getValidateRecipeMutationKey = () => ['validateRecipe'] as const;

export const getValidateRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateRecipe>>, TError,ValidateRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof validateRecipe>>, TError,ValidateRecipeMutationVariables, TContext> => {

const mutationKey = getValidateRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateRecipe>>, ValidateRecipeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  validateRecipe(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof validateRecipe>>>

    export type ValidateRecipeMutationError = ErrorType<unknown>
    export type ValidateRecipeMutationVariables = {id: number}

    /**
 * @summary Mark recipe as validated
 */
export const useValidateRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateRecipe>>, TError,ValidateRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateRecipe>>,
        TError,
        ValidateRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getValidateRecipeMutationOptions(options), queryClient);
    }

export const getFlagRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}/flag`
}

/**
 * @summary Mark recipe as needs_correction
 */
export const flagRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

  return customFetch<RecipeDetail>(getFlagRecipeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFlagRecipeMutationKey = () => ['flagRecipe'] as const;

export const getFlagRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagRecipe>>, TError,FlagRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof flagRecipe>>, TError,FlagRecipeMutationVariables, TContext> => {

const mutationKey = getFlagRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flagRecipe>>, FlagRecipeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  flagRecipe(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FlagRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof flagRecipe>>>

    export type FlagRecipeMutationError = ErrorType<unknown>
    export type FlagRecipeMutationVariables = {id: number}

    /**
 * @summary Mark recipe as needs_correction
 */
export const useFlagRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagRecipe>>, TError,FlagRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof flagRecipe>>,
        TError,
        FlagRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getFlagRecipeMutationOptions(options), queryClient);
    }

export const getReextractRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}/reextract`
}

/**
 * @summary Re-run AI extraction, overwriting current recipe data in-place
 */
export const reextractRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

  return customFetch<RecipeDetail>(getReextractRecipeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReextractRecipeMutationKey = () => ['reextractRecipe'] as const;

export const getReextractRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reextractRecipe>>, TError,ReextractRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reextractRecipe>>, TError,ReextractRecipeMutationVariables, TContext> => {

const mutationKey = getReextractRecipeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reextractRecipe>>, ReextractRecipeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reextractRecipe(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReextractRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof reextractRecipe>>>

    export type ReextractRecipeMutationError = ErrorType<unknown>
    export type ReextractRecipeMutationVariables = {id: number}

    /**
 * @summary Re-run AI extraction, overwriting current recipe data in-place
 */
export const useReextractRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reextractRecipe>>, TError,ReextractRecipeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reextractRecipe>>,
        TError,
        ReextractRecipeMutationVariables,
        TContext
      > => {
      return useMutation(getReextractRecipeMutationOptions(options), queryClient);
    }

export const getListFavoritesUrl = () => {




  return `/api/favorites`
}

/**
 * @summary List the current household's favorite recipes (newest first)
 */
export const listFavorites = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListFavorites200> => {

  return customFetch<ListFavorites200>(getListFavoritesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFavoritesQueryKey = () => {
    return [
    `/api/favorites`
    ] as const;
    }


export const getListFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFavoritesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFavorites>>> = ({ signal }) => listFavorites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof listFavorites>>>
export type ListFavoritesQueryError = ErrorType<unknown>


export function useListFavorites<TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavorites>>,
          TError,
          Awaited<ReturnType<typeof listFavorites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFavorites<TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavorites>>,
          TError,
          Awaited<ReturnType<typeof listFavorites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFavorites<TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the current household's favorite recipes (newest first)
 */

export function useListFavorites<TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFavoritesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddFavoriteUrl = (recipeId: number,) => {




  return `/api/favorites/${recipeId}`
}

/**
 * @summary Mark a recipe as favorite (idempotent)
 */
export const addFavorite = async (recipeId: number, options?: Parameters<typeof customFetch>[1]): Promise<AddFavorite200> => {

  return customFetch<AddFavorite200>(getAddFavoriteUrl(recipeId),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getAddFavoriteMutationKey = () => ['addFavorite'] as const;

export const getAddFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,AddFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,AddFavoriteMutationVariables, TContext> => {

const mutationKey = getAddFavoriteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFavorite>>, AddFavoriteMutationVariables> = (props) => {
          const {recipeId} = props ?? {};

          return  addFavorite(recipeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof addFavorite>>>

    export type AddFavoriteMutationError = ErrorType<unknown>
    export type AddFavoriteMutationVariables = {recipeId: number}

    /**
 * @summary Mark a recipe as favorite (idempotent)
 */
export const useAddFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,AddFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFavorite>>,
        TError,
        AddFavoriteMutationVariables,
        TContext
      > => {
      return useMutation(getAddFavoriteMutationOptions(options), queryClient);
    }

export const getRemoveFavoriteUrl = (recipeId: number,) => {




  return `/api/favorites/${recipeId}`
}

/**
 * @summary Remove a recipe from favorites (idempotent)
 */
export const removeFavorite = async (recipeId: number, options?: Parameters<typeof customFetch>[1]): Promise<RemoveFavorite200> => {

  return customFetch<RemoveFavorite200>(getRemoveFavoriteUrl(recipeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveFavoriteMutationKey = () => ['removeFavorite'] as const;

export const getRemoveFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,RemoveFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,RemoveFavoriteMutationVariables, TContext> => {

const mutationKey = getRemoveFavoriteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFavorite>>, RemoveFavoriteMutationVariables> = (props) => {
          const {recipeId} = props ?? {};

          return  removeFavorite(recipeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof removeFavorite>>>

    export type RemoveFavoriteMutationError = ErrorType<unknown>
    export type RemoveFavoriteMutationVariables = {recipeId: number}

    /**
 * @summary Remove a recipe from favorites (idempotent)
 */
export const useRemoveFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,RemoveFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeFavorite>>,
        TError,
        RemoveFavoriteMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveFavoriteMutationOptions(options), queryClient);
    }

export const getListFavoriteCollectionsUrl = () => {




  return `/api/favorite-collections`
}

/**
 * @summary List all favorite collections (with recipe counts)
 */
export const listFavoriteCollections = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListFavoriteCollections200> => {

  return customFetch<ListFavoriteCollections200>(getListFavoriteCollectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFavoriteCollectionsQueryKey = () => {
    return [
    `/api/favorite-collections`
    ] as const;
    }


export const getListFavoriteCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listFavoriteCollections>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFavoriteCollectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFavoriteCollections>>> = ({ signal }) => listFavoriteCollections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFavoriteCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listFavoriteCollections>>>
export type ListFavoriteCollectionsQueryError = ErrorType<unknown>


export function useListFavoriteCollections<TData = Awaited<ReturnType<typeof listFavoriteCollections>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavoriteCollections>>,
          TError,
          Awaited<ReturnType<typeof listFavoriteCollections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFavoriteCollections<TData = Awaited<ReturnType<typeof listFavoriteCollections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavoriteCollections>>,
          TError,
          Awaited<ReturnType<typeof listFavoriteCollections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFavoriteCollections<TData = Awaited<ReturnType<typeof listFavoriteCollections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all favorite collections (with recipe counts)
 */

export function useListFavoriteCollections<TData = Awaited<ReturnType<typeof listFavoriteCollections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFavoriteCollections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFavoriteCollectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateFavoriteCollectionUrl = () => {




  return `/api/favorite-collections`
}

/**
 * @summary Create a new favorite collection
 */
export const createFavoriteCollection = async (createFavoriteCollectionBody: CreateFavoriteCollectionBody, options?: Parameters<typeof customFetch>[1]): Promise<FavoriteCollectionRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<FavoriteCollectionRecord>(getCreateFavoriteCollectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFavoriteCollectionBody)
  }
);}





export const getCreateFavoriteCollectionMutationKey = () => ['createFavoriteCollection'] as const;

export const getCreateFavoriteCollectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFavoriteCollection>>, TError,CreateFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFavoriteCollection>>, TError,CreateFavoriteCollectionMutationVariables, TContext> => {

const mutationKey = getCreateFavoriteCollectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFavoriteCollection>>, CreateFavoriteCollectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFavoriteCollection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFavoriteCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof createFavoriteCollection>>>
    export type CreateFavoriteCollectionMutationBody = BodyType<CreateFavoriteCollectionBody>
    export type CreateFavoriteCollectionMutationError = ErrorType<void>
    export type CreateFavoriteCollectionMutationVariables = {data: BodyType<CreateFavoriteCollectionBody>}

    /**
 * @summary Create a new favorite collection
 */
export const useCreateFavoriteCollection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFavoriteCollection>>, TError,CreateFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFavoriteCollection>>,
        TError,
        CreateFavoriteCollectionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFavoriteCollectionMutationOptions(options), queryClient);
    }

export const getGetFavoriteCollectionUrl = (collectionId: number,) => {




  return `/api/favorite-collections/${collectionId}`
}

/**
 * @summary Get one collection with its recipes
 */
export const getFavoriteCollection = async (collectionId: number, options?: Parameters<typeof customFetch>[1]): Promise<GetFavoriteCollection200> => {

  return customFetch<GetFavoriteCollection200>(getGetFavoriteCollectionUrl(collectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFavoriteCollectionQueryKey = (collectionId: number,) => {
    return [
    `/api/favorite-collections/${collectionId}`
    ] as const;
    }


export const getGetFavoriteCollectionQueryOptions = <TData = Awaited<ReturnType<typeof getFavoriteCollection>>, TError = ErrorType<void>>(collectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFavoriteCollectionQueryKey(collectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFavoriteCollection>>> = ({ signal }) => getFavoriteCollection(collectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: collectionId !== null && collectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFavoriteCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof getFavoriteCollection>>>
export type GetFavoriteCollectionQueryError = ErrorType<void>


export function useGetFavoriteCollection<TData = Awaited<ReturnType<typeof getFavoriteCollection>>, TError = ErrorType<void>>(
 collectionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavoriteCollection>>,
          TError,
          Awaited<ReturnType<typeof getFavoriteCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFavoriteCollection<TData = Awaited<ReturnType<typeof getFavoriteCollection>>, TError = ErrorType<void>>(
 collectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavoriteCollection>>,
          TError,
          Awaited<ReturnType<typeof getFavoriteCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFavoriteCollection<TData = Awaited<ReturnType<typeof getFavoriteCollection>>, TError = ErrorType<void>>(
 collectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one collection with its recipes
 */

export function useGetFavoriteCollection<TData = Awaited<ReturnType<typeof getFavoriteCollection>>, TError = ErrorType<void>>(
 collectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFavoriteCollection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFavoriteCollectionQueryOptions(collectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateFavoriteCollectionUrl = (collectionId: number,) => {




  return `/api/favorite-collections/${collectionId}`
}

/**
 * @summary Rename a favorite collection
 */
export const updateFavoriteCollection = async (collectionId: number,
    updateFavoriteCollectionBody: UpdateFavoriteCollectionBody, options?: Parameters<typeof customFetch>[1]): Promise<FavoriteCollectionRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<FavoriteCollectionRecord>(getUpdateFavoriteCollectionUrl(collectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFavoriteCollectionBody)
  }
);}





export const getUpdateFavoriteCollectionMutationKey = () => ['updateFavoriteCollection'] as const;

export const getUpdateFavoriteCollectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFavoriteCollection>>, TError,UpdateFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFavoriteCollection>>, TError,UpdateFavoriteCollectionMutationVariables, TContext> => {

const mutationKey = getUpdateFavoriteCollectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFavoriteCollection>>, UpdateFavoriteCollectionMutationVariables> = (props) => {
          const {collectionId,data} = props ?? {};

          return  updateFavoriteCollection(collectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFavoriteCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateFavoriteCollection>>>
    export type UpdateFavoriteCollectionMutationBody = BodyType<UpdateFavoriteCollectionBody>
    export type UpdateFavoriteCollectionMutationError = ErrorType<void>
    export type UpdateFavoriteCollectionMutationVariables = {collectionId: number;data: BodyType<UpdateFavoriteCollectionBody>}

    /**
 * @summary Rename a favorite collection
 */
export const useUpdateFavoriteCollection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFavoriteCollection>>, TError,UpdateFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFavoriteCollection>>,
        TError,
        UpdateFavoriteCollectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFavoriteCollectionMutationOptions(options), queryClient);
    }

export const getDeleteFavoriteCollectionUrl = (collectionId: number,) => {




  return `/api/favorite-collections/${collectionId}`
}

/**
 * @summary Delete a favorite collection (recipes themselves are not deleted)
 */
export const deleteFavoriteCollection = async (collectionId: number, options?: Parameters<typeof customFetch>[1]): Promise<DeleteFavoriteCollection200> => {

  return customFetch<DeleteFavoriteCollection200>(getDeleteFavoriteCollectionUrl(collectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteFavoriteCollectionMutationKey = () => ['deleteFavoriteCollection'] as const;

export const getDeleteFavoriteCollectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFavoriteCollection>>, TError,DeleteFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFavoriteCollection>>, TError,DeleteFavoriteCollectionMutationVariables, TContext> => {

const mutationKey = getDeleteFavoriteCollectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFavoriteCollection>>, DeleteFavoriteCollectionMutationVariables> = (props) => {
          const {collectionId} = props ?? {};

          return  deleteFavoriteCollection(collectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFavoriteCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFavoriteCollection>>>

    export type DeleteFavoriteCollectionMutationError = ErrorType<unknown>
    export type DeleteFavoriteCollectionMutationVariables = {collectionId: number}

    /**
 * @summary Delete a favorite collection (recipes themselves are not deleted)
 */
export const useDeleteFavoriteCollection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFavoriteCollection>>, TError,DeleteFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFavoriteCollection>>,
        TError,
        DeleteFavoriteCollectionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteFavoriteCollectionMutationOptions(options), queryClient);
    }

export const getAddRecipeToFavoriteCollectionUrl = (collectionId: number,
    recipeId: number,) => {




  return `/api/favorite-collections/${collectionId}/recipes/${recipeId}`
}

/**
 * @summary Add a recipe to a collection (idempotent)
 */
export const addRecipeToFavoriteCollection = async (collectionId: number,
    recipeId: number, options?: Parameters<typeof customFetch>[1]): Promise<AddRecipeToFavoriteCollection200> => {

  return customFetch<AddRecipeToFavoriteCollection200>(getAddRecipeToFavoriteCollectionUrl(collectionId,recipeId),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getAddRecipeToFavoriteCollectionMutationKey = () => ['addRecipeToFavoriteCollection'] as const;

export const getAddRecipeToFavoriteCollectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>, TError,AddRecipeToFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>, TError,AddRecipeToFavoriteCollectionMutationVariables, TContext> => {

const mutationKey = getAddRecipeToFavoriteCollectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>, AddRecipeToFavoriteCollectionMutationVariables> = (props) => {
          const {collectionId,recipeId} = props ?? {};

          return  addRecipeToFavoriteCollection(collectionId,recipeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddRecipeToFavoriteCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>>

    export type AddRecipeToFavoriteCollectionMutationError = ErrorType<void>
    export type AddRecipeToFavoriteCollectionMutationVariables = {collectionId: number;recipeId: number}

    /**
 * @summary Add a recipe to a collection (idempotent)
 */
export const useAddRecipeToFavoriteCollection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>, TError,AddRecipeToFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addRecipeToFavoriteCollection>>,
        TError,
        AddRecipeToFavoriteCollectionMutationVariables,
        TContext
      > => {
      return useMutation(getAddRecipeToFavoriteCollectionMutationOptions(options), queryClient);
    }

export const getRemoveRecipeFromFavoriteCollectionUrl = (collectionId: number,
    recipeId: number,) => {




  return `/api/favorite-collections/${collectionId}/recipes/${recipeId}`
}

/**
 * @summary Remove a recipe from a collection (idempotent)
 */
export const removeRecipeFromFavoriteCollection = async (collectionId: number,
    recipeId: number, options?: Parameters<typeof customFetch>[1]): Promise<RemoveRecipeFromFavoriteCollection200> => {

  return customFetch<RemoveRecipeFromFavoriteCollection200>(getRemoveRecipeFromFavoriteCollectionUrl(collectionId,recipeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveRecipeFromFavoriteCollectionMutationKey = () => ['removeRecipeFromFavoriteCollection'] as const;

export const getRemoveRecipeFromFavoriteCollectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>, TError,RemoveRecipeFromFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>, TError,RemoveRecipeFromFavoriteCollectionMutationVariables, TContext> => {

const mutationKey = getRemoveRecipeFromFavoriteCollectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>, RemoveRecipeFromFavoriteCollectionMutationVariables> = (props) => {
          const {collectionId,recipeId} = props ?? {};

          return  removeRecipeFromFavoriteCollection(collectionId,recipeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveRecipeFromFavoriteCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>>

    export type RemoveRecipeFromFavoriteCollectionMutationError = ErrorType<unknown>
    export type RemoveRecipeFromFavoriteCollectionMutationVariables = {collectionId: number;recipeId: number}

    /**
 * @summary Remove a recipe from a collection (idempotent)
 */
export const useRemoveRecipeFromFavoriteCollection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>, TError,RemoveRecipeFromFavoriteCollectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeRecipeFromFavoriteCollection>>,
        TError,
        RemoveRecipeFromFavoriteCollectionMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveRecipeFromFavoriteCollectionMutationOptions(options), queryClient);
    }

export const getListCollectionsForRecipeUrl = (id: number,) => {




  return `/api/recipes/${id}/collections`
}

/**
 * @summary List collections that contain a given recipe
 */
export const listCollectionsForRecipe = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ListCollectionsForRecipe200> => {

  return customFetch<ListCollectionsForRecipe200>(getListCollectionsForRecipeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCollectionsForRecipeQueryKey = (id: number,) => {
    return [
    `/api/recipes/${id}/collections`
    ] as const;
    }


export const getListCollectionsForRecipeQueryOptions = <TData = Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCollectionsForRecipeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollectionsForRecipe>>> = ({ signal }) => listCollectionsForRecipe(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCollectionsForRecipeQueryResult = NonNullable<Awaited<ReturnType<typeof listCollectionsForRecipe>>>
export type ListCollectionsForRecipeQueryError = ErrorType<unknown>


export function useListCollectionsForRecipe<TData = Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollectionsForRecipe>>,
          TError,
          Awaited<ReturnType<typeof listCollectionsForRecipe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollectionsForRecipe<TData = Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollectionsForRecipe>>,
          TError,
          Awaited<ReturnType<typeof listCollectionsForRecipe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollectionsForRecipe<TData = Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List collections that contain a given recipe
 */

export function useListCollectionsForRecipe<TData = Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionsForRecipe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollectionsForRecipeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadHeroImageUrl = (id: number,) => {




  return `/api/recipes/${id}/hero-image`
}

/**
 * @summary Upload or replace the hero photo for a recipe
 */
export const uploadHeroImage = async (id: number,
    uploadHeroImageBody: UploadHeroImageBody, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {
    const formData = new FormData();
formData.append(`image`, uploadHeroImageBody.image);

  return customFetch<RecipeDetail>(getUploadHeroImageUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadHeroImageMutationKey = () => ['uploadHeroImage'] as const;

export const getUploadHeroImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHeroImage>>, TError,UploadHeroImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadHeroImage>>, TError,UploadHeroImageMutationVariables, TContext> => {

const mutationKey = getUploadHeroImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadHeroImage>>, UploadHeroImageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  uploadHeroImage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadHeroImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadHeroImage>>>
    export type UploadHeroImageMutationBody = BodyType<UploadHeroImageBody>
    export type UploadHeroImageMutationError = ErrorType<unknown>
    export type UploadHeroImageMutationVariables = {id: number;data: BodyType<UploadHeroImageBody>}

    /**
 * @summary Upload or replace the hero photo for a recipe
 */
export const useUploadHeroImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHeroImage>>, TError,UploadHeroImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadHeroImage>>,
        TError,
        UploadHeroImageMutationVariables,
        TContext
      > => {
      return useMutation(getUploadHeroImageMutationOptions(options), queryClient);
    }

export const getDeleteHeroImageUrl = (id: number,) => {




  return `/api/recipes/${id}/hero-image`
}

/**
 * @summary Remove the hero photo from a recipe
 */
export const deleteHeroImage = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecipeDetail> => {

  return customFetch<RecipeDetail>(getDeleteHeroImageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHeroImageMutationKey = () => ['deleteHeroImage'] as const;

export const getDeleteHeroImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHeroImage>>, TError,DeleteHeroImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHeroImage>>, TError,DeleteHeroImageMutationVariables, TContext> => {

const mutationKey = getDeleteHeroImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHeroImage>>, DeleteHeroImageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteHeroImage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHeroImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHeroImage>>>

    export type DeleteHeroImageMutationError = ErrorType<unknown>
    export type DeleteHeroImageMutationVariables = {id: number}

    /**
 * @summary Remove the hero photo from a recipe
 */
export const useDeleteHeroImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHeroImage>>, TError,DeleteHeroImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHeroImage>>,
        TError,
        DeleteHeroImageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteHeroImageMutationOptions(options), queryClient);
    }

